"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionAttributesSchema = exports.PaymentStatus = void 0;
const zod_1 = require("zod");
exports.PaymentStatus = {
    OPEN: 'open',
    PAID: 'paid',
    EXPIRED: 'expired',
    PENDING: 'pending',
    VOID: 'void',
};
exports.TransactionAttributesSchema = zod_1.z.object({
    id: zod_1.z.number(),
    orderId: zod_1.z.number(),
    invoiceId: zod_1.z.number().nullable().optional(),
    creditNoteId: zod_1.z.number().nullable().optional(),
    uuid: zod_1.z.string(),
    expiresAt: zod_1.z.date(),
    xenditId: zod_1.z.string().nullable().optional(),
    xenditInvoiceUrl: zod_1.z.string().nullable().optional(),
    paymentMethod: zod_1.z.string().nullable().optional(),
    amount: zod_1.z.number(),
    paidAt: zod_1.z.date().nullable().optional(),
    paymentChannel: zod_1.z.string().nullable().optional(),
    paymentStatus: zod_1.z.nativeEnum(exports.PaymentStatus),
    paymentDestination: zod_1.z.string().nullable().optional(),
});
//# sourceMappingURL=transaction.js.map